import { logAppError } from './analytics';

const PROJECT_ID = import.meta.env.VITE_FIREBASE_PROJECT_ID as string;
const API_KEY = import.meta.env.VITE_FIREBASE_API_KEY as string;
const SERVICE = 'mhc-court-pulse-web';

// Only report in production — skip during local dev
const enabled = import.meta.env.PROD && !!PROJECT_ID && !!API_KEY;

export function reportError(err: unknown, context?: string): void {
  const error = err instanceof Error ? err : new Error(String(err));
  
  // Log to Firebase Analytics telemetry
  try {
    logAppError(context ? `[${context}] ${error.message}` : error.message, error.stack, false);
  } catch {}

  if (!enabled) {
    console.error(context ? `[${context}]` : '[error]', err);
    return;
  }

  const message = [
    context ? `[${context}] ${error.message}` : error.message,
    error.stack ?? '',
  ].join('\n');

  const body = JSON.stringify({
    serviceContext: { service: SERVICE },
    message,
    context: {
      httpRequest: {
        url: window.location.href,
        userAgent: navigator.userAgent,
      },
    },
  });

  // Fire-and-forget — don't await, don't let reporting errors surface to users
  fetch(
    `https://clouderrorreporting.googleapis.com/v1beta1/projects/${PROJECT_ID}/events:report?key=${API_KEY}`,
    { method: 'POST', body, headers: { 'Content-Type': 'application/json' } }
  ).catch(() => { /* reporting failure is silent */ });
}
